import React from 'react';

function Loader(_props) {
    return (
        <div id="pageloader" className="white-loader">
		    <div className="spinner">
		        <div className="bounce1"></div>
		        <div className="bounce2"></div>
		        <div className="bounce3"></div>
		    </div>
		</div>
    );
}

Loader.propTypes = {};
Loader.defaultProps = {};
Loader.contextTypes = {};

export default Loader;



/** WEBPACK FOOTER **
 ** ./src/components/Loader.js
 **/